import React, { useEffect, useState } from "react";
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";
import Button from "components/button";
import useModal from "components/modal/useModal";
import { MESSAGE_REGEX } from "helper/helper";
import UseContext from "hooks/useContext";
import StyledInput from "components/styledInput/StyledInput";

const Accroissement = () => {
    const { data, setData, language } = UseContext();
    const label = (key, defaultValue) =>
        language.getValue(`missionCreation.motifForm.${key}`, defaultValue);
    const [validMotif, setValidMotif] = useState(false);
    // Reopening the modal shows the motif already confirmed, as long as it is this one.
    const [message, setMessage] = useState(() => ({
        type: "1",
        message: data.motif?.type === "1" ? data.motif.message ?? "" : "",
    }));
    const [lengthMessage, setLengthMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [validMessage, setValidMessage] = useState(false);
    const { toggle } = useModal();
    const verif = message.message.length;
    useEffect(() => {
        setValidMessage(MESSAGE_REGEX.test(message.message));

        if (verif <= 8) {
            setErrorMessage(true);
            setLengthMessage(false);
        } else {
            setErrorMessage(false);
            setLengthMessage(true);
        }
        if (message.motif !== "0") {
            setValidMotif(true);
        } else {
            setValidMotif(false);
        }
    }, [message, verif]);
    const handleMessage = (e) => {
        setMessage({ ...message, message: e.target.value });
    };
    const handleSubmit = () => {
        if (lengthMessage) {
            setData((prevData) => ({ ...prevData, motif: message }));
            toggle();
        }
    };
    return (
        <>
            <Modalheader
                hide={toggle}
                hideShow={true}
                closeLabel={language.getValue("missionCreation.modal.close", "Fermer")}
                description={label("reasonDescriptions.temporaryActivity", "Pour faire face à une hausse ponctuelle de l'activité : commande exceptionnelle, surcroît de travail passager ou tâche occasionnelle hors de votre activité habituelle.")}
            >
                Accroissement temporaire d'activité
            </Modalheader>
            {/*body*/}
            <ModalBody>
                <form className="flex flex-col w-full gap-4">
                    <StyledInput
                        type={"textarea"}
                        placeholder={label("reasonPlaceholders.temporaryActivity", "Ex. : commande exceptionnelle d'un client, inventaire annuel, ouverture d'un nouveau rayon…")}
                        label={label("description", "Votre description")}
                        value={message.message}
                        maxLength={250}
                        minLength={10}
                        isLengthInvalid={!!errorMessage}
                        onChange={handleMessage}
                    />
                </form>
            </ModalBody>
            {/*footer*/}
            <ModalFooter>
                <Button size={"LG"} color={"SECONDARY"} onClick={toggle}>
                    Annuler
                </Button>
                <Button size={"LG"} onClick={handleSubmit}>
                    Confirmer
                </Button>
            </ModalFooter>
        </>
    );
};

export default Accroissement;
